import { Component } from '@angular/core';

@Component({
  selector: 'mtm-globe-icon',
  templateUrl: './mtm-globe-icon.component.html',
  standalone: true,
})
export class MtmGlobeIconComponent {}
